<template>
    <section id="login">
        <div class="c fadeInUp flex -wrap -justify-center">

            <div class="centered__item about__intro text-center">
                <img src="/img/crown.svg" class="crown" /><br />
            </div>

            <div class="-flex-stretch"></div>

            <form id="login_form" v-show="mode != 'twofactor'" @submit.prevent="submit">
                <h2>{{ $t('login.states.title') }}</h2>
                <div class="form__fields">
                    <fieldset>
                        <label for="login_email">{{ $t('login.fields.email') }}</label>
                        <input class="input" type="email" autocomplete="email" v-model="values.email" required autofocus />
                    </fieldset>

                    <fieldset v-if="mode == 'verify'">
                        <label for="login_password">{{ $t('login.fields.password') }}</label>
                        <input class="input" type="password" autocomplete="password" v-model="values.password" required />
                    </fieldset>
                    <br />
                    <div v-if="mode == 'verify'">
                        <button type="submit" class="w-100" :class="{ '--loading': loading }" form="login_form">{{ $t('login.actions.login') }}</button>
                        <button type="button" class="button_neutral w-100" @click="change_mode('forgotpassword');">{{ $t('login.actions.password_forgot') }}</button>
                    </div>

                    <div v-if="mode == 'forgotpassword'">
                        <button type="submit" class="w-100" :class="{ '--loading': loading }" >{{ $t('login.actions.password_reset') }}</button>
                        <button type="button" class="button_neutral w-100" @click="change_mode('verify');" form="login_form">{{ $t('login.actions.login') }}</button>
                    </div>
                </div>
            </form>

            <form id="login__totp_form" v-if="mode == 'twofactor'" @submit.prevent="submit2fa">
                <h1 class="accent weight-b">{{ $t('login.states.title_2fa') }}</h1>
                <br />

                <div class="form__fields">
                    <fieldset>
                        <label for="login_token">{{ $t('login.fields.verification_code') }}</label>
                        <input class="input" type="number" step="1" id="login_token" name="code" v-model.number="values.code" required autofocus />
                    </fieldset>
                </div>

                <button type="submit" class="w-100 bg-accent" :class="{ '--loading': loading }" form="login__totp_form">{{ $t('login.actions.login') }}</button>
                <button type="button" class="w-100" @click="change_mode('verify');">{{ $t('login.actions.cancel') }}</button>
            </form>
            <transition name="fade">
                <div v-if="loading" class="loader -is-fixed">
                    <!-- loader -->
                    <span class="fa rotate page-is-loading">&#xf110;</span>
                </div>
            </transition>

        </div>
    </section>
</template>

<script>
export default {
    name: 'Login',
    data() {
        return {
            mode: 'verify',
            values: {
                email: '',
                password: '',
                code: '',
                user: null,
            },
        };
    },
    mounted() {
        if (this.$route.path.startsWith('/logout')) {
            this.$store.dispatch('Auth/logout');
        } else {
            this.$store.dispatch('Auth/getSmartLock', this.values);
        }
    },
    methods: {
        change_mode(name) {
            this.mode = name;
        },

        submit() {
            if (this.loading) { return false; }
            if (this.mode === 'verify') {
                this.$store.dispatch('Auth/login', this.values)
                    .then((r) => {
                        if (r.twofactor) {
                            this.mode = 'twofactor';
                            this.values.user = r.user;
                        } else {
                            this.login_success(r);
                        }
                    })
                    .catch(() => {});
            } else if (this.mode === 'forgotpassword') {
                this.$store.dispatch('Auth/passreset', this.values)
                    .then(() => {
                        this.mode = 'verify';
                    })
                    .catch(() => {});
            }
            return true;
        },

        submit2fa() {
            this.$store.dispatch('Auth/twofactor', this.values)
                .then((r) => {
                    this.login_success(r);
                })
                .catch(() => {});
        },

        login_success() {
            if (this.$route.query.redirect) {
                router.push(this.$route.query.redirect);
            } else {
                router.push('/producten/products');
            }
        },
    },
    computed: {
        loading() {
            return this.$store.state.app.loading;
        },
    },
};
</script>

<style>
    .layout__login {
        display: grid;
        grid-template-columns: minmax(0, 70rem) 1fr;
        grid-template-areas: "login side";
        height: 100vh;
        width: 100%;
        background: var(--color-white);
    }
        .layout__login content {
            grid-area: login;
            max-width: var(--column-width-max);
            align-self: center;
            justify-self: center;
            width: 100%;
        }
            .layout__login content .avatar {
                margin: 0 0 var(--padding-xl) 0;
            }
        .login__side {
            grid-area: side;
            background-color: var(--color-accent-dark);
            background-image: url('/img/bgs/blixem.svg'), url('/img/blixem_logo_white.svg');
            background-repeat: repeat, no-repeat;
            background-size: 70rem auto, 5rem auto;
            background-position: 0 0, 50% 50%;
        }

    @media (max-width: 50rem) {
        .layout__login {
            grid-template-columns: 1fr;
            grid-template-rows: 20rem auto;
            grid-template-areas:
                "side"
                "login";
            height: auto;
            min-height: 100%;
        }
            .layout__login content {
                align-self: flex-start;
                padding: var(--padding-xl) var(--padding-l);
            }

            .layout__login .avatar {
                position: absolute;
                top: var(--padding-xl)
            }
    }
    @media (max-width: 30rem) {
        .layout__login {
            grid-template-rows: 12rem auto;
        }
    }
</style>
